<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container>
      <!-- 主表单区域 -->
      <a-form :form="form" slot="detail">
        <a-row>

          <a-col :span="12">
            <a-form-item :label="$t('label.contractID')" :labelCol="labelCol" :wrapperCol="wrapperCol">

              <a-select :placeholder="$t('label.pleaseSelectTheContractNumber')"
                        @change="handleConCodeChanged"
                        ref="findConCode"
                        v-decorator="['conCode', validatorRules.conCode]"
                        :disabled="conCodeStatus"
                        showSearch option-filter-prop="children"  option-label-prop="label">
                <a-select-option
                  v-for="item in conCodeList"
                  :key="item.code"
                  :label="item.code"
                  :value="item.code">
                  {{ item.code + '|' + item.name}}
                </a-select-option>
              </a-select>
              <!--              <j-search-select-tag :disabled="isContractCodeDisabled" v-decorator="['contractCode']"-->
              <!--                                   dict="efs_md_contract,code,code"/>-->
            </a-form-item>
          </a-col>
<!--          <a-col :span="12">-->
<!--            <a-form-item label="合同编码" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
<!--              <j-search-select-tag-option-is-value-text-->
<!--                @change="handleConCodeChanged"-->
<!--                ref="findConCode"-->
<!--                v-decorator="['conCode', validatorRules.conCode]"-->
<!--                dict="efs_md_contract,name,code" />-->
<!--            </a-form-item>-->
<!--          </a-col>-->
          <a-col :span="12" >
            <a-form-item :label="$t('label.effectiveDate')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date :placeholder="$t('label.pleaseSelectEffectiveDate')"  :disabled="true" v-decorator="['effectiveDate']" :trigger-change="true" style="width: 100%" />
            </a-form-item>
          </a-col>
         <!-- <a-col :span="12">
            <a-form-item label="批次编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag-option-is-value-text disabled v-decorator="['breedBatchCode', validatorRules.breedBatchCode]" dict="efs_md_breed_batch,name,code" />
            </a-form-item>
          </a-col>-->
          <a-col :span="12">
            <a-form-item :label="$t('label.validOrNot')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag disabled type="list" v-decorator="['validFlag',{'initialValue':'Y'}]" :trigger-change="true" dictCode="sfyx"  :placeholder="$t('label.pleaseChooseWhetherItIsValidOrNot')"/>
            </a-form-item>
          </a-col>
          <a-col :span="6" >
          </a-col>
          <a-col :span="12" v-show="buttonStatus">
            <a-button @click="handleTableSelect"  type="primary" icon="check" >{{ $t('button.drawDownContractPriceList') }}</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
    <!-- 子表单区域 -->
    <a-tabs v-model="activeKey" @change="handleChangeTabs">
      <a-tab-pane :tab="$t('tabName.contractPriceListDetails')" :key="refKeys[0]" :forceRender="true">
        <j-editable-table
          :ref="refKeys[0]"
          :loading="efsMdContractPriceListDetailTable.loading"
          :columns="efsMdContractPriceListDetailTable.columns"
          :dataSource="efsMdContractPriceListDetailTable.dataSource"
          :maxHeight="300"
          :disabled="formDisabled"
          :rowNumber="true"
          :rowSelection="true"
        />
      </a-tab-pane>
    </a-tabs>
  </a-spin>
</template>

<script>

import pick from 'lodash.pick'
import { getAction } from '@/api/manage'
import { FormTypes,getRefPromise } from '@/utils/JEditableTableUtil'
import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
import { validateDuplicateValue } from '@/utils/util'
import JFormContainer from '@/components/jeecg/JFormContainer'
import JDictSelectTag from "@/components/dict/JDictSelectTag"
import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
import JSearchSelectTagOptionIsValueText from '@/components/dict/JSearchSelectTagOptionIsValueText'
import { getMtrlCodeWithMaxversion, getMtrlCodeWithByConCode, getConfirmByBatchCode, getContractByCode } from '@api/api'

export default {
  name: 'EfsMdContractPriceListForm',
  mixins: [JEditableTableMixin],
  components: {
    JFormContainer,
    JDictSelectTag,
    JSearchSelectTagOptionIsValueText,
    JSearchSelectTag,
  },
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 3 },
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
      // 新增时子表默认添加几行空数据
      addDefaultRowNum: 1,
      conCodeStatus:false,
        buttonStatus:true,
      validatorRules: {
        conCode: {
          rules: [
            { required: true, message: this.$t('label.pleaseEnterTheContractCode')},
            { validator: (rule, value, callback) => validateDuplicateValue('efs_md_contract_price_list', 'con_code', value, this.model.id, callback)},
          ]
        },
        /*breedBatchCode: {
          rules: [
            { required: true, message: '请输入批次编码!'},
          ]
        },*/
      },
      refKeys: ['efsMdContractPriceListDetail', ],
      tableKeys:['efsMdContractPriceListDetail', ],
      activeKey: 'efsMdContractPriceListDetail',
      // 合同价格清单详情
      efsMdContractPriceListDetailTable: {
        loading: false,
        dataSource: [],
        columns: [
          {
            title: this.$t('tableHeader.materialCode'),
            key: 'mmCode',
            type: FormTypes.input,
            width:"140px",
            placeholder: this.$t('tip.pleaseInput') +'${title}',
            disabled: true,
            defaultValue: '',
          },
          {
            title: this.$t('tableHeader.materialCategory'),
            key: 'mmCategory',
            type: FormTypes.sel_search,
            dictCode:"efs_md_mm_group,name,code",
            width:"200px",
            placeholder: this.$t('tip.pleaseInput') +'${title}',
            disabled: true,
            defaultValue: '',
          },
          {
            title: this.$t('tableHeader.materialName'),
            key: 'mmName',
            type: FormTypes.input,
            width:"200px",
            placeholder: this.$t('tip.pleaseInput') +'${title}',
            disabled: true,
            defaultValue: '',
          },
          {
            title: this.$t('tableHeader.specification'),
            key: 'spec',
            type: FormTypes.input,
            width:"200px",
            placeholder: this.$t('tip.pleaseInput') +'${title}',
            disabled: true,
            defaultValue: '',
          },
          {
            title: this.$t('tableHeader.model'),
            key: 'model',
            type: FormTypes.input,
            width:"200px",
            placeholder: this.$t('tip.pleaseInput') +'${title}',
            disabled: true,
            defaultValue: '',
          },
          {
            title: this.$t('tableHeader.mainUnitOfMeasurement'),
            key: 'unit',
            type: FormTypes.sel_search,
            dictCode:"sys_dict_item,item_text,item_value,dict_id=(select id from sys_dict where dict_code='material_unit_type')",
            width:"100px",
            placeholder: this.$t('tip.pleaseInput') +'${title}',
            disabled: true,
            defaultValue: '',
          },
          {
            title: this.$t('tableHeader.settlementUnitPrice'),
            key: 'price',
            type: FormTypes.inputNumber,
            width:"100px",
            placeholder: this.$t('tip.pleaseInput') +'${title}',
            defaultValue: '',
          },
          {
            title: this.$t('tableHeader.version'),
            key: 'version',
            type: FormTypes.hidden,
            disabled:true,
            width:"100px",
            placeholder: this.$t('tip.pleaseInput') +'${title}',
            defaultValue: '',
          },
            {
                title: this.$t('tableHeader.effectiveDate'),
                key: 'effectiveDate',
                type: FormTypes.hidden,
                disabled:true,
                width:"100px",
                placeholder: this.$t('tip.pleaseInput') +'${title}',
                defaultValue: '',
            },
            {
                title: this.$t('tableHeader.materialCategory'),
                key: 'categoryCode',
                type: FormTypes.hidden,
                disabled:true,
                width:"100px",
                placeholder: this.$t('tip.pleaseInput') +'${title}',
                defaultValue: '',
            },
          // {
          //   title: '说明描述',
          //   key: 'description',
          //   type: FormTypes.input,
          //   width:"200px",
          //   placeholder: '请输入${title}',
          //   defaultValue: '',
          // },
         /* {
            title: '是否有效',
            key: 'validFlag',
            type: FormTypes.input,
            width:"200px",
            placeholder: '请输入${title}',
            dictCode:"sfyx",
            disabled: true,
            defaultValue: '',
          },*/
        ]
      },
      url: {
        add: "/contractPriceList/efsMdContractPriceList/add",
        edit: "/contractPriceList/efsMdContractPriceList/edit",
        queryByContractCodeWithMaxversion: "/contractManage/efsMdContract/queryByContractCodeWithMaxversion",
        queryById: "/contractPriceList/efsMdContractPriceList/queryById",
        efsMdContractPriceListDetail: {
          list: '/contractPriceList/efsMdContractPriceList/queryEfsMdContractPriceListDetailByMainId'
        },
      },
      conCodeList:[],//合同
    }
  },
  props: {
    //流程表单data
    formData: {
      type: Object,
      default: ()=>{},
      required: false
    },
    //表单模式：false流程表单 true普通表单
    formBpm: {
      type: Boolean,
      default: false,
      required: false
    },
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    formDisabled(){
      if(this.formBpm===true){
        if(this.formData.disabled===false){
          return false
        }
        return true
      }
      return this.disabled
    },
    showFlowSubmitButton(){
      if(this.formBpm===true){
        if(this.formData.disabled===false){
          return true
        }
      }
      return false
    }
  },
  created () {
    //如果是流程中表单，则需要加载流程表单data
    getContractByCode({contractCode: ""}).then((res) => {
      if (res.success) {
        this.conCodeList = res.result.priceContract;
      }
    });
    this.showFlowData();
  },
  methods: {
    addBefore(){
      this.form.resetFields()
      this.efsMdContractPriceListDetailTable.dataSource=[]
    },
    getAllTable() {
      let values = this.tableKeys.map(key => getRefPromise(this, key))
      return Promise.all(values)
    },
    /** 调用完edit()方法之后会自动调用此方法 */
    editAfter() {
      let fieldval = pick(this.model,'conCode','validFlag','effectiveDate')
      this.$nextTick(() => {
        this.form.setFieldsValue(fieldval)
      })
      // 加载子表数据
      if (this.model.id) {
        this.conCodeStatus=true;
        this.buttonStatus=false;
        let params = { id: this.model.id }
        this.requestSubTableData(this.url.efsMdContractPriceListDetail.list, params, this.efsMdContractPriceListDetailTable)
      }else{
          this.conCodeStatus=false;
          this.buttonStatus=true;
      }
    },
    /** 整理成formData */
    classifyIntoFormData(allValues) {
      let main = Object.assign(this.model, allValues.formValue)
      return {
        ...main, // 展开
        efsMdContractPriceListDetailList: allValues.tablesValue[0].values,
      }
    },
    //渲染流程表单数据
    showFlowData(){
      if(this.formBpm === true){
        let params = {id:this.formData.dataId};
        getAction(this.url.queryById,params).then((res)=>{
          if(res.success){
            this.edit (res.result);
          }
        })
      }
    },
    validateError(msg){
      this.$message.error(msg)
    },
    popupCallback(row){
      this.form.setFieldsValue(pick(row,'conCode','validFlag','effectiveDate'))
    },
    handleConCodeChanged(event){
      getAction(this.url.queryByContractCodeWithMaxversion, { code: event }).then(res => {
        if (res.success) {
          //this.form.resetFields()
          this.form.setFieldsValue({
            //conCode: res.result.conCode,
            //breedBatchCode: res.result.breedBatchCode,
            effectiveDate: res.result.conStartDate,
          })
        } else {
          this.$message.warning(res.message)
        }
      })
    },

    handleTableSelect() {
      let _request = {
        conCode:  this.$refs.findConCode.value,
        type:1
      }
      getMtrlCodeWithByConCode(_request).then(res => {
        if (res.success) {
          for (let i = 0; i < res.result.length; i++) {
            let mm = res.result[i]
              mm.mmCode=mm.mmCode,
              mm.mmCategory=mm.mmCategory,
              mm.mmName=mm.mmName,
              mm.spec=mm.spec,
              mm.model=mm.model,
              mm.unit=mm.unit,
              mm.price=mm.price,
              mm.description=mm.description,
              mm.validFlag=mm.validFlag
          }
          this.efsMdContractPriceListDetailTable.dataSource = res.result;
        } else {
          this.efsMdContractPriceListDetailTable.dataSource = [];
            this.$message.warning(res.message);
        }
      })
    },
  }
}
</script>

<style scoped>
</style>